// @flow

import {TextAlign, VerticalAlign} from './constants';


export type VerticalAlignType = $Values<typeof VerticalAlign>;
export type TextAlignType = $Values<typeof TextAlign>;


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
